export class InvalidOptionsError extends Error {
  public readonly type = "invalid_options";
  public readonly caller: string;
  constructor(caller: string) {
    super(`invalid_options: ${caller}`);
    this.caller = caller;
  }
}
